import { isAxiosError } from "axios";

import type { ApiErrorBody } from "../../types/api";

type ApiHeaders = {
  headers: {
    Accept: string;
    Authorization?: string;
  };
};

export const headers = (accessToken?: string | null): ApiHeaders => {
  let headersHash: ApiHeaders["headers"];
  if (accessToken) {
    headersHash = { Accept: "application/json", Authorization: accessToken };
  } else {
    headersHash = { Accept: "application/json" };
  }
  return { headers: headersHash };
};

export const host: string | undefined = process.env.REACT_APP_API_ENDPOINT;

export const getApiErrorMessage = (error: unknown): string | undefined =>
  isAxiosError<ApiErrorBody>(error) ? error.response?.data?.error : undefined;
